<login-home-navigation></login-home-navigation>

<section class="sptb" style= "background-color:#fff;padding-top: 10%;">
    <div class="container">
        <h2>Schedule your time slot for upcoming webinar as per your manufacturing category</h2>
        <div class="row">
          
            <div class="col-lg-2 col-md-2 col-sm-2">
                <img src="../../../assets/images/media/livweb.gif" width="80%" height="80%" (click)="openDialog()">
            </div>
            <div class="col-lg-10 col-md-10 col-sm-8">
                <img src="../../../assets/images/media/machineweb.webp" width="80%" height="90%">
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2"> 

            </div>

        </div>
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2">
                <img src="../../../assets/images/media/livweb.gif" width="80%" height="80%" (click)="openDialog()">
            </div>
            <div class="col-lg-10 col-md-10 col-sm-8">
                <img src="../../../assets/images/media/pressweb.webp" width="80%" height="90%">
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2">

            </div>

        </div>
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2">
                <img src="../../../assets/images/media/livweb.gif" width="80%" height="80%" (click)="openDialog()">
            </div>
            <div class="col-lg-10 col-md-10 col-sm-8">
                <img src="../../../assets/images/media/forgingweb.webp" width="80%" height="90%">
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2">

            </div>

        </div>
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2">
                <img src="../../../assets/images/media/livweb.gif" width="80%" height="80%" (click)="openDialog()">
            </div>
            <div class="col-lg-10 col-md-10 col-sm-8">
                <img src="../../../assets/images/media/castweb.webp" width="80%" height="90%">
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2">

            </div>

        </div>
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2">
                <img src="../../../assets/images/media/livweb.gif" width="80%" height="80%" (click)="openDialog()">
            </div>
            <div class="col-lg-10 col-md-10 col-sm-8">
                <img src="../../../assets/images/media/fabweb.webp" width="80%" height="90%">
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2">

            </div>

        </div>



    </div>
</section>
<section style="background-color:black ;padding-top:5px;">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="container">
            <div class="row">
    
            
            <div class="col-lg-8 col-md-8 col-sm-8 signup">
                <p>Don't fall behind your competitors! If you have the manufacturing setup, join the custom manufacturing community for free.
            </p></div>
            <div class="col-lg-4 col-md-4 col-sm-4">
                <button class="sgnbtn" (click)="signup()">SIGN UP NOW <i class="fa fa-sign-in"></i></button>
            </div>
            
            </div>
        </div>
    </div>
    
</section>
<login-home-footer></login-home-footer>
